import {
  FileOutlined,
} from "@ant-design/icons";
import { IRouter } from "~/routers";
import {
  HomeView,
  PrivacyPolicyView,
  TermsRegisterView,
  TermsServiceView,
} from "~/views/main";
import BlogListView from "~/views/main/blog";
import ComingSoonPage from "~/views/main/comming-soon";
import { ContactView } from "~/views/main/contact";
import BlogDetail from "~/views/main/home/pages/blog-detail";
import RegisterPackagePage from "~/views/main/register-package";
import SystemDetailPage from "~/views/main/system";
import ErpMiniPage from "~/views/main/products/erpMini";
import CrmPage from "~/views/main/products/crm";
import DmsPage from "~/views/main/products/dms";
import PmPage from "~/views/main/products/pm";
import PmsPage from "~/views/main/products/pms";
import MesPage from "~/views/main/products/mes";
import TmsPage from "~/views/main/products/tms";
import WmsPage from "~/views/main/products/wms";
import EamPage from "~/views/main/products/eam";
import HrmPage from "~/views/main/products/hrm";

const createRoute = (
  path: string,
  element: JSX.Element,
  title?: string,
  icon?: JSX.Element,
  isMenu = true,
  children: IRouter[] = []
): IRouter => ({
  path,
  key: `route-${path}`,
  element,
  title,
  isMenu,
  icon,
  children,
});



export const mainRouter: IRouter[] = [
  createRoute("/", <HomeView />, "Trang chủ", <FileOutlined />, false),
  createRoute("contact", <ContactView />, "Liên hệ", <FileOutlined />, false),
  createRoute("blog/:id", <BlogDetail />, "Chi tiết Bài viết", <FileOutlined />, false),
  createRoute("system/:slug/:documentId", <SystemDetailPage />, "Chi tiết hệ thống", <FileOutlined />, false),
  createRoute("register-package", <RegisterPackagePage />, "Đăng ký gói", <FileOutlined />, false),
  createRoute("blog", <BlogListView />, "Bài viết", <FileOutlined />, false),
  createRoute(
    "privacy-policy",
    <PrivacyPolicyView />,
    "Chính sách bảo mật",
    <FileOutlined />,
    false
  ),
  createRoute(
    "terms-service",
    <TermsServiceView />,
    "Điều khoản dịch vụ",
    <FileOutlined />,
    false
  ),
  createRoute(
    "terms-register",
    <TermsRegisterView />,
    "Điều khoản và điều kiện",
    <FileOutlined />,
    false
  ),
  createRoute("hrm", <HrmPage />, "HRM", <FileOutlined />, false),
  createRoute("erpMini", <ErpMiniPage />, "ERP Mini", <FileOutlined />, false),
  createRoute("crm", <CrmPage />, "CRM", <FileOutlined />, false),
  createRoute("dms", <DmsPage />, "DMS", <FileOutlined />, false),
  createRoute("pm", <PmPage />, "PM", <FileOutlined />, false),
  createRoute("pms", <PmsPage />, "PMS", <FileOutlined />, false),
  createRoute("mes", <MesPage />, "MES", <FileOutlined />, false),
  createRoute("tms", <TmsPage />, "TMS", <FileOutlined />, false),
  createRoute("wms", <WmsPage />, "WMS", <FileOutlined />, false),
  createRoute("eam", <EamPage />, "EAM", <FileOutlined />, false),
   createRoute("*", 
    <ContactView 
    />, 
    "Coming Soon", 
    <FileOutlined />, 
    false
  ),
];
